import { render } from "./survey-start.component.vue?vue&type=template&id=aca8a61e&ts=true"
import script from "./survey-start.component.vue?vue&type=script&lang=ts"
export * from "./survey-start.component.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__